import icCloseSquare from "assets/images/ic-close-square.svg";
import Button from "components/commons/button";
import { Import } from "components/commons/import/Import";
import Modal from "components/commons/modal";
import { TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT } from "configs/hr-metrics/configTableEmployeeProductivityList";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { API_EMPLOYEE_PRODUCTIVITY } from "services/apiEmployeeProductivity";

export const ImportEmployeeProductivityContainer = ({show, onHide}) => {
    const [searchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        if (show) setIsComplete(false)
    }, [show])

    const api = {
        fetchTemplate:{...API_EMPLOYEE_PRODUCTIVITY.DOWNLOAD_TEMPLATE, api: API_EMPLOYEE_PRODUCTIVITY.DOWNLOAD_TEMPLATE.api + `/${periodId}`},
        fetchValidate:{...API_EMPLOYEE_PRODUCTIVITY.FILE_VALIDATION, api: API_EMPLOYEE_PRODUCTIVITY.FILE_VALIDATION.api + `/${periodId}`},
        fetchImport:{...API_EMPLOYEE_PRODUCTIVITY.IMPORT, api: API_EMPLOYEE_PRODUCTIVITY.IMPORT.api + `/${periodId}`},
    }

    const props = {
        title: 'Employee Productivity',
        columnTableView: TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT,
        api: api,
        returnTitle: 'View Employee Productivity',
        onHide: onHide,
        setCompleteImport: (value) => setIsComplete(value)
    }

    return (
        <Modal
            dialogClassName="w-[70%]"
            contentClassName="rounded-xl"
            show={show}
        >
            <div className={"px-6 py-3 flex flex-row items-center justify-between border-b"}>
                <p className={"font-semibold text-md"}>Import Data</p>
                <Button type="outline" shape="circle" size="small" icon={icCloseSquare} onClick={() => onHide(isComplete)}/>
            </div>
            <div className="overflow-auto">
                <Import {...props}/>
            </div>
        </Modal>
    )
}
